import { Arch1 } from './Arch1';

export default Arch1;
